import useContract from './useContract';
import TokenVault from '../contracts/TokenVault.json';

const useTokenVault = () =>
  useContract(
    process.env.NEXT_PUBLIC_TOKEN_VAULT_CONTRACT_ADDRESS,
    TokenVault.abi
  );

export default useTokenVault;
